import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-button-scroll',
  templateUrl: './button-scroll.component.html',
  styleUrls: ['./button-scroll.component.scss']
})
export class ButtonScrollComponent implements OnInit {

  @Input() location: 'top' | 'bottom';

  @Input() moveTo: ButtonScrollComponent;

  @ViewChild('elementRef') div: ElementRef;

  tooltipPosition: string;
  tooltip: string;

  constructor() { }

  ngOnInit(): void {
    this.tooltip = this.location == 'top' ? 'Ir abajo' : 'Ir arriba';
    this.tooltipPosition = this.location == 'top' ? 'below' : 'above';
  }

  goTo = () => {
    this.moveTo.div.nativeElement.scrollIntoView();
  }

}
